import { render, staticRenderFns } from "./EditFormsModal.vue?vue&type=template&id=2e970022&scoped=true&"
import script from "./EditFormsModal.vue?vue&type=script&lang=js&"
export * from "./EditFormsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFormsModal.vue?vue&type=style&index=0&id=2e970022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e970022",
  null
  
)

export default component.exports